import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@src/languages';
import CommonAvatar from '@src/new-components/Avatar';
import Typography from '@src/new-components/Typography';
import verifiedIcon from '@src/assets/icons/verified-rounded.svg';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded';
import { COLOR } from '@src/styles/color';
import { getFrameVoiceUrl } from '@src/services/voiceCloning';
import {
  StyledVoiceCard,
  StyledVoiceCardContent,
  StyledVoiceCardHeader,
} from './index.style';

export const UnderlinedUnit = () => (
  <span style={{ textDecoration: 'underline' }}>đ</span>
);
export const PercentUnit = () => <span>%</span>;

const VoiceCard = ({ voiceData }) => {
  const { t } = useTranslation();
  const { language } = i18n;
  const cardsData = [
    {
      title: t('totalCharactersUsed'),
      value: `${voiceData?.totalCredits?.toLocaleString(language)}`,
      icon: (
        <SubjectRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      ),
    },
    {
      title: t('tentativeRevenue'),
      value: `${voiceData?.totalMoneyVnd?.toLocaleString(language)}`,
      icon: (
        <MonetizationOnRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      ),
      showUnit: true,
    },
  ];

  const showTagsVoice = [voiceData?.voice?.category, voiceData?.voice?.gender]
    ?.filter(Boolean)
    ?.map((tag) => t(tag))
    ?.join(' • ');

  return (
    <StyledVoiceCard className="voice-card">
      <StyledVoiceCardHeader>
        <CommonAvatar
          avatar={voiceData?.voice?.roundImage}
          badgeIcon={
            <img src={verifiedIcon} alt="badge" className="verified-icon" />
          }
          size={64}
          className="voice-card-avatar"
          frameImageUrl={getFrameVoiceUrl(voiceData?.voice)}
        />
        <div className="voice-card-header-info">
          <Typography variant="body-20-bold" color={COLOR.darkGray}>
            {voiceData?.voice?.name}
          </Typography>
          <Typography variant="body-14-regular" color={COLOR.colorVoiceCard}>
            {showTagsVoice}
          </Typography>
        </div>
      </StyledVoiceCardHeader>
      <StyledVoiceCardContent>
        {cardsData.map((card) => (
          <div className="voice-card-content-item" key={card.title}>
            <div className="voice-card-content-item-info">
              {card.icon}
              <Typography
                variant="body-14-regular"
                color={COLOR.descriptionUpload}
              >
                {card.title}
              </Typography>
            </div>
            <Typography variant="body-16-medium" color={COLOR.darkGray}>
              {card.showUnit && <UnderlinedUnit />}
              {card.value}
            </Typography>
          </div>
        ))}
      </StyledVoiceCardContent>
    </StyledVoiceCard>
  );
};

export default VoiceCard;
